import React from 'react';

import FancyTitle from '~/src/common/services/Builder/components/other/fancyTitle/Component';
import PromoExplanations from '~/src/common/services/Builder/components/section/promoExplanationItems/Component';

import { PropsFromInputs } from '../../types';

import { Container, HeaderContainer, StyledWaves } from './layout';

type Props = PropsFromInputs<typeof import('./inputs').default>;

export default ({ title, subtitle, items }: Props) => {
  return (
    <Container>
      <HeaderContainer>
        <StyledWaves />
        <FancyTitle title={title} />
        <span>{subtitle}</span>
      </HeaderContainer>
      <PromoExplanations items={items} />
    </Container>
  );
};
